import React, { useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ReCAPTCHA from "react-google-recaptcha";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import HomeHeader from "../../home/homeHeader";
import AllDashboard from "../../mainMenu/allDashboard/index";
// import { Login } from "../services/Un_auth_services";
import ALLRoutes from "../../router/router";
import useAuth from "../../../hooks/useAuth";
import { useSelector } from "react-redux";
import axios from "axios";
import { verifyCaptcha } from "../services/privateapicalling";
 import { toast,ToastContainer } from "react-toastify";
type PasswordField = "password";
 
const Login2 = () => {
  const recaptchaRef = useRef(null);
  const routes = all_routes;
  const navigation = useNavigate();
  const language = useSelector((state: any) => state.auth.language);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const role = params.get("role");

  const [credentials, setCredentials] = useState({
    Email: null,
    password: null,
    Username: null
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [alertMessage, setAlertMessage] = useState<React.ReactNode>(null);
  const [alertVisible, setAlertVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage);
  const [isLoading, setIsLoading] = useState(false);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [islogin, setIsLogin] = useState(false);
 
  const { signIn } = useAuth();
 
  const handleRecaptchaChange = async(token) => {
    // setIsRecaptchaVerified(true); // Just mark it as verified
      const captchaRes = await verifyCaptcha(token);
      if (captchaRes.success) {
        setIsRecaptchaVerified(true);
      }
       else {
        setErrorMessage("CAPTCHA failed. Try again.");
      }
 
  };
 
  //("role test", role);
 
  const rolesWithUsername = [
    "Trader_Login",
    "Panel_Engineer_Login",
    "District_Registrar_Login",
    "APMC_Login",
    "Head_Officer_Login",
    "GCA_Login",
    "Sponsor_Login",
    "MBA_Login",
    "DM_Login"
  ];
 
 const allowedRoles = [
    "Trader_Registration",
    "Panel_Engineer_Registration",
    "Trader_Login",
    "Panel_Engineer_Login",
    "District_Registrar_Login",
    "APMC_Login",
    "Head_officer_Login",
    "GCA_Login",
     "GCA_Registration",
     "Sponsor_Login",
     "Sponsor_Registration"
  ];
  useEffect(() => {
    if (!allowedRoles.includes(role ?? "")) {
      navigation(routes.error404);
    }
  }, [role]);
 
  let isUsernameField = rolesWithUsername.includes(role ?? "");
 
  // useEffect(() => {
  //   if (role && role !== "User" && !rolesWithUsername.includes(role)) {
  //     navigation(routes.Home);
  //   }
  // }, [role, navigation]);
 
  const handleGetOtp = () => {
    navigation(routes.twoStepVerification3);
  };
 
  // const togglePasswordVisibility = (field: PasswordField) => {
  //   setPasswordVisibility((prevState) => ({
  //     ...prevState,
  //     [field]: !prevState[field],
  //   }));
  // };
 
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
 
  const handleLogin = async (e: React.FormEvent) => {
 
   const currrole = params.get("role")==="Sponsor_Login"?"Contract_Farming_Login":params.get("role");
  
    // setCredentials({ ...credentials, ["userType"]: role });
    // setCredentials((prev) => ({
    //   ...prev,
    //   userType: currrole
    // }));
      if (!isRecaptchaVerified) {
      setErrorMessage("Please complete the reCAPTCHA verification.");

      return;
    }
    
    setIsLoading(true);
    e.preventDefault();
  
    try {
   
    const newCred = {
      ...credentials,
      userType:currrole
    };
   
 
      const response = await signIn(newCred);
      setIsLoading(false);
      ////.log("Login Response:", response);
      setCredentials({
        Email: null,
        password: null,
        Username: null
      });
 
      if (response?.success===true) {
        setIsLogin(true)
        // alert(response.message);
        // localStorage.setItem("token", response.Body);
        // navigation(all_routes.profile);
      } else if (response?.togetVerified) {
        setIsLogin(true)
        // alert(response.Message);
        ////.log("ppppppppp",response.RefId)
        const pr = response.RefId;
 
        navigation(all_routes.twoStepVerification3, {
          state: {
            formValues: {
              UserName: credentials["Username"],
              password: credentials["password"],
              userType: credentials["userType"],
            },
            // navigatePath: "profile",
            pr: pr,
          },
        });
      }  else {
        setIsLogin(true)
        toast.error(response?.Message);
        setErrorMessage("Invalid email or password.");
      }
      
 
     
    } catch (error) {
      //.error("Login Error:", error);
        toast.error("Something went wrong. Please try again.");
      setErrorMessage("Something went wrong. Please try again.");
    }
  };
  ////.log("role", role);
 
  useEffect(() => {
  if (isRecaptchaVerified) {
    recaptchaRef.current?.reset(); 
  }
}, [setIsLogin]);
 
  return (
    <>
      <HomeHeader />
 
      <div className="container-fuild">
        <div className="d-block flex-wrap position-relative w-100 overflow-hidden vh-100">
          <div className="row">
            <div className="col-lg-7 d-lg-block d-none p-0 position-relative vh-100">
              <div className="h-100 position-absolute w-100 start-0 top-0">
                <ImageWithBasePath
                  src="assets/img/Login-1.jpg"
                  alt="Img"
                  className="h-100 w-100"
                />
              </div>
            </div>
 
            <div className="col-lg-5 col-md-12 col-sm-12 bg-white">
              <div className="flex-wrap row align-items-center justify-content-center overflow-auto vh-100">
                <div className="col-md-10 mx-auto vh-100">
                  <form className="vh-100">
                    <div className="d-flex flex-column justify-content-between p-4 pb-0 vh-100">
                      <div className="text-center mb-5 mx-auto"></div>
                      <div className="">
                        <div className="text-center mb-3">
                          <h2
                            className="mb-4"
                            style={{ fontSize: "25px", fontWeight: "bold" }}
                          >
                            {language.login}
                          </h2>
                          {/* <p className="mb-0">{language.login_heading}</p> */}
                        </div>
                        <div className="mb-3">
                          <label className="form-label fs-23 fw-bold">
                            {role == "Panel_Engineer_Login" ||
                            role == "Trader_Login" || role == "GCA_Login" ||role=="Sponsor_Login"
                              ? `${language.email}`
                              : `${language.username}`}
                          </label>
                          <span className="text-danger"> * </span>
 
                          <div className="input-group">
                            <input
                              type="text"
                              autoComplete="new-Email ID"
                              name={
                                role === "Panel_Engineer_Login" ||
                                role === "Trader_Login" || role === "GCA_Login"|| role=="Sponsor_Login"
                                  ? "Email"
                                  : "UserName"
                              }
                              value={
                                role === "Panel_Engineer_Login" ||
                                role === "Trader_Login" || role === "GCA_Login"||role=="Sponsor_Login"
                                  ? credentials.Email || ""
                                  : credentials.Username || ""
                              }
                              onChange={(e) =>
                                setCredentials((prev) => ({
                                  ...prev,
                                  [role === "Panel_Engineer_Login" ||
                                  role === "Trader_Login" || role === "GCA_Login" ||role=="Sponsor_Login"
                                    ? "Email"
                                    : "Username"]: e.target.value,
                                }))
                              }
                              className="form-control border-end-0"
                              placeholder={`Enter your ${
                                role === "Panel_Engineer_Login" ||
                                role === "Trader_Login" || role === "GCA_Login" ||role=="Sponsor_Login"
                                  ? "Email"
                                  : "Username"
                              }`}
                              required
                            />
 
                            <span className="input-group-text border-start-0">
                              <i
                                className={
                                  role === "Panel_Engineer_Login" ||
                                  role === "Trader_Login" || role === "GCA_Login" ||role=="Sponsor_Login"
                                    ? "ti ti-mail"
                                    : "ti ti-user"
                                }
                              />
                            </span>
                          </div>
                        </div>
 
                        <div className="mb-3">
                          <label className="form-label fs-23 fw-bold">
                           {language.password}
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-group">
                            <input
                              type={passwordVisibility ? "text" : "password"}
                              name="password"
                              value={
                                credentials.password ? credentials.password : ""
                              }
                              onChange={handleChange}
                              autoComplete="new-password"
                              placeholder="Enter your Password"
                              className="form-control"
                              required
                            />
                            <span
                              className="input-group-text border-start-0"
                              onClick={() =>
                                setPasswordVisibility(!passwordVisibility)
                              }
                            >
                              <i
                                className={
                                  passwordVisibility
                                    ? "fas fa-eye"
                                    : "fas fa-eye-slash"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                        {errorMessage && (
                          <p className="text-danger">{errorMessage}</p>
                        )}
                        
                        <div className="d-flex justify-content-center text-center my-3">
                          <ReCAPTCHA
                            sitekey= {siteKey}
                             ref={recaptchaRef} 
                            onChange={handleRecaptchaChange}
                            size="normal"
                          />
                        </div>
 
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <div className="form-check form-check-md mb-1 mt-1">
                              <input
                                className="form-check-input"
                                id="remember_me"
                                type="checkbox"
                              />
                              <label
                                htmlFor="remember_me"
                                className="form-check-label mt-0"
                              >
                                {language.remember}
                              </label>
                            </div>
                          </div>
                          <div className="text-end">
                            <Link
                              to={`${all_routes.forgotPassword3}?role=${role}`}
                              className="link-success"
                            >
                              {language.forgot_password}?
                            </Link>
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            className="btn btn-success w-100"
                            onClick={handleLogin}
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <i className="ion-load-a ion-spin"></i> // Loading spinner
                            ) : (
                              `${language.sign_in}`
                            )}
                          </button>
                        </div>
                        {["Trader_Login", "Panel_Engineer_Login","GCA_Login","Sponsor_Login"].includes(
                          role
                        ) && (
                          <div className="text-center">
                            <h6 className="fw-normal text-dark mb-0">
                              {language.dontaccount}
                              <Link
                                to={`${
                                  all_routes.register3
                                }?role=${role.replace(
                                  "_Login",
                                  "_Registration"
                                )}`}
                                className="text-success"
                              >
                                &nbsp; {language.create_account}
                              </Link>
                            </h6>
                          </div>
                        )}
 
                        <div className="login-or">{}</div>
                        <div className="mt-2"></div>
                      </div>
                      <div className="mt-5 pb-4 text-center pr-4"></div>
                      {/* <div className="d-flex justify-content-end fixed-bottom p-3">
                        <button
                          type="button"
                          className="btn btn-lg btn-success rounded-pill shadow-lg px-4 py-2 d-flex align-items-center gap-2"
                          data-bs-toggle="modal"
                          data-bs-target="#con-close-modal"
                        >
                          {language.support}
                        </button>
                      </div> */}
                      <div
                        id="con-close-modal"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog position-fixed bottom-0 end-0 m-3"
                          style={{ width: "350px" }}
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h4 className="modal-title">
                                {language.help_supp}
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              />
                            </div>
                            <div className="modal-body p-4">
                              <div className="mb-3">
                                <label htmlFor="field-1" className="form-label">
                                  {language.sel_role}
                                </label>
                                <select className="form-control" id="field-1">
                                  <option value="">Select an option</option>
                                  <option value="unified_trader_license">
                                    {language.utl}
                                  </option>
                                  <option value="panel_engineer">
                                    {language.p_eng}
                                  </option>
                                  <option value="apmc">{language.apmc}</option>
                                  <option value="district_registrar">
                                    {language.dist_reg}
                                  </option>
                                  <option value="head_office">
                                    {language.ho_office}
                                  </option>
                                </select>
                              </div>
 
                              <div className="mb-3">
                                <label htmlFor="field-3" className="form-label">
                                  {language.mobile}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="field-3"
                                  placeholder="Enter Mobile No."
                                />
                              </div>
 
                              <div>
                                <label htmlFor="field-7" className="form-label">
                                  {language.issue}
                                </label>
                                <textarea
                                  className="form-control"
                                  id="field-7"
                                  placeholder="Write your issue here"
                                />
                              </div>
                            </div>
 
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-cancel"
                                data-bs-dismiss="modal"
                              >
                                {language.close}
                              </button>
                              <button type="button" className="btn btn-primary">
                                {language.submit}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} position="top-right"/>
    </>
  );
};
 
export default Login2;
function setErrorMessage(arg0: string) {
  throw new Error("Function not implemented.");
}